// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1aXQB","consentsList":"PatientConsents_consentsList__wSgy4","consentsListEmpty":"PatientConsents_consentsListEmpty__2YR-y"};